import { render, staticRenderFns } from "./CheckInBalanceWidget.vue?vue&type=template&id=054f9c8b"
import script from "./CheckInBalanceWidget.vue?vue&type=script&lang=js"
export * from "./CheckInBalanceWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports